import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    getRes: null,
};

const slice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        getRequest: (state) => {
            state.loading = true;
        },
        getSuccess: (state, action) => {
            state.loading = false;
            state.getRes = action.payload;
        },
        getFailure: (state, action) => {
            state.loading = false;
            state.getRes = action.payload;
        },
        resetGet: (state) => {
            state.getRes = null;
        },
    },
});

export const { getRequest, getSuccess, getFailure, resetGet } = slice.actions;
export default slice.reducer;
